// import React from 'react'
// import { Card } from 'antd';

// const SalesReturnReportFooter = ({ locationId }) => {
//   return (
//     <div className='order_report_footer'
//     // style={{width: "1150px"}}
//     >
//       <div style={{ display: "flex", justifyContent: "space-between" }}>
//         <Card style={{ width: "475px" }}>
//           <p className='footer_order_p' style={{ display: "flex", justifyContent: "center", textDecoration: "underline" }}>Return Instruction</p>
//           <p className='footer_order_p'>1) No return will be accepted without RA#.</p>
//           <p className='footer_order_p'>2) All Return must include a copy of this packing list.</p>
//           <p className='footer_order_p'>3) Only approved styles and Quantities are returnable against this RA.</p>
//           <p className='footer_order_p'>4) Returns will not be accepted if merchandise has a sensor on it.</p>
//           <p className='footer_order_p'>5) Return will not be accepted after expire date.</p>
//           <p className='footer_order_p'>6) Only Credit Memo will be issued for returned goods - no refund.</p>
//           <p className='footer_order_p'>7) There will be a deduction of 5% if the returned unit is missing waist tag.</p>
//           <p className='footer_order_p'>8) Returns without an advance shipping notice (including tracking#) and an approved RA# will not be processed.</p>
//           <p className='footer_order_p'>9) RA credits will not be issued for merchandise that is worn, stained, or damaged.</p>
//         </Card>

//         {
//           locationId === 1 ?
//             <Card style={{ width: "310px" }}>
//               <p className='footer_order_p' style={{ display: "flex", justifyContent: "center", textDecoration: "underline" }}>Return Address</p>
//               <p className='footer_order_p'>Warp Weft World Showroom<br />
//                 121 Varick St, 4th Floor<br />
//                 New York, NY 10013 <br />
//                 Tel: 646.514.9736</p>
//             </Card>
//             :
//             <Card style={{ width: "310px" }}>
//               <p className='footer_order_p' style={{ display: "flex", justifyContent: "center", textDecoration: "underline" }}>Return Address</p>
//               <p className='footer_order_p'>DL1961 Premium Denim c/o Bergen Logistics <br />
//                 299 Thomas E. Dunn Memorial Highway<br />
//                 Rutherford, NJ 07070 <br />
//                 Contact Person: Karla Hernandez <br />
//                 Tel: 201 624 2170 Ext.231  <br />
//                 Tel: 201 854 8136</p>
//             </Card>
//         }
//       </div>

//     </div>
//   )
// }

// export default SalesReturnReportFooter;

const SalesInvoiceReportFooter = ({ locationId }) => {
  return (
    <div className="__footer">
      <table width="100%">
        <tbody>
          <tr>
            <td style={{ height: 0 }} width="55%" >
              <MyCard heading="Return Instructions">
                {/* <p>
                  1) No return will be accepted without RA#.<br />
                  2) All Return must include a copy of this packing list.<br />
                  3) Only approved styles and Quantities are returnable against this RA.<br />
                  4) Returns will not be accepted if merchandise has a sensor on it.<br />
                  5) Return will not be accepted after expire date.<br />
                  6) Only Credit Memo will be issued for returned goods - no refund.<br />
                  7) There will be a deduction of 5% if the returned unit is missing waist tag.<br />
                  8) Returns without an advance shipping notice (including tracking#) and an approved RA# will not be processed.<br />
                  9) RA credits will not be issued for merchandise that is worn, stained, or damaged.<br />
                  10) Seller-provided shipping label/call tag charges will be deducted from the credit memo.
                </p> */}
                <p>
                  1) Return Requirements: All returns must include a packing list, RA number, and tracking number. Returns submitted after 45 days of shipment or without a valid RA number will not be accepted or credited.<br />
                  2) Damaged Goods: Damaged items must be reported within 10 days of shipment. Please submit a Return Authorization (RA) request with photos clearly showing the defect.<br />
                  3) Non-Returnable Items: RA credits will not be issued for white garments, discounted items, or any goods that are worn or stained.<br />
                  4) Handling Fee: A 5% handling fee will be applied to any product that is mishandled or returned without tags.<br />
                  5) Credit Processing: Please allow 1-2 weeks for a credit note to be issued once your return is received.<br />
                </p>
              </MyCard>
            </td>
            <td style={{ height: 0 }} width="12%" className='__footer_col_2' />
            <td style={{ height: 0 }} width="33%" >
              {locationId === 1 ?
                <MyCard heading="Return Address">
                  <p>
                    Warp Weft World Showroom<br />
                    121 Varick St, 4th Floor<br />
                    New York, NY 10013 <br />
                    Tel: 646.514.9736
                  </p>
                </MyCard>
                :
                <MyCard heading="Return Address">
                  <p>
                    Warp Weft World Inc. c/o Bergen Logistics <br />
                    299 Thomas E. Dunn Memorial Highway<br />
                    Rutherford, NJ 07070 <br />
                    Contact Person: Karla Hernandez <br />
                    {/* Tel: 201 624 2170 Ext.231  <br />
                    Tel: 201 854 8136 */}
                  </p>
                </MyCard>
              }
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}

export default SalesInvoiceReportFooter;

const MyCard = ({ heading, children }) => (
  <div className="__card">
    {heading && <h4
      style={{
        display: "flex",
        justifyContent: "center",
        textDecoration: "underline",
      }}
    >{heading}</h4>}
    {children}
  </div>
)